<template lang="pug">
  .room.anchor-room(v-loading="loadingData")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" :class="warningFlag1")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts2" :series="flowData" :class="warningFlag3")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts0" :series="SingleSolidPieData0" :class="warningFlag2")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts1" :series="SingleSolidPieData1" :class="warningFlag4")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts2" :series="SingleSolidPieData2" :class="warningFlag5")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts3" :series="SingleSolidPieData3" :class="warningFlag6")
    .divice-block-line
      SinglePieHistogramWrap.divice-block-line-item(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" :class="warningFlag7")
      SinglePieHistogramWrap.divice-block-line-item(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" :class="warningFlag8")
      .divice-block-line-item.divice-block-line-col
        SwitchStatus.divice-block-thin(title="锚室送风机指示" :series="SwitchStatusData2")
        SwitchStatus.divice-block-thin(title="高压风机指示" :series="SwitchStatusData5")
        SwitchStatus.divice-block-thin(title="变频器运行" :series="SwitchStatusData1")
        RunningTimeBig.divice-block-time(title="锚室送风机运行时间" :series="RunningTimeData1")
      .divice-block-line-item.divice-block-line-col
        SwitchStatus.divice-block-thin(title="锚室送风机故障" :series="SwitchStatusData3")
        SwitchStatus.divice-block-thin(title="高压送风机故障" :series="SwitchStatusData6")
        SwitchStatus.divice-block-thin(title="变频器故障" :series="SwitchStatusData4")
        RunningTimeBig.divice-block-time(title="高压风机运行时间" :series="RunningTimeData2")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/anchorAfan_data.json'

export default {
  name: 'anchorAfan',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      warningFlag7: '',
      warningFlag8: '',
      pressure: {},
      flowData: {},
      deviceList: [],
      singleHisOpts1: {
        title: '高压风机送风压力',
        histogramName1: 'P',
        max: 15000,
        sign: 'W'
      },
      singleHisOpts2: {
        title: '高压风机送风流量',
        histogramName1: 'Flow',
        max: 150,
        sign: 'm³/h'
      },
      SingleSolidPieOpts0: { title: '高压风机送风压力', max: 15000 },
      SingleSolidPieOpts1: { title: '初效过滤压差', max: 200 },
      SingleSolidPieOpts2: { title: '中效过滤压差', max: 200 },
      SingleSolidPieOpts3: { title: '高效过滤压差', max: 200 },
      SingleSolidPieData0: {},
      SingleSolidPieData1: {},
      SingleSolidPieData2: {},
      SingleSolidPieData3: {},
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SwitchStatusData5: null,
      SwitchStatusData6: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapOpts1: {
        title: '高压风机送风温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '前锚温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts3: {
        title: '制备站温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      RunningTimeData1: null,
      RunningTimeData2: null
    }
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  created() {
    this.setTitles()
  },
  mounted() {
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
      this.warningFlag6 = ''
      this.warningFlag7 = ''
      this.warningFlag8 = ''
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      const routerPath = this.$route.name.split('_')
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/deviceData/Station?stationId=${stationId}`).then(res => {
        this.loadingData = false
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData1',
          this.findDeviceId('高压风机送风温度(℃)'),
          this.findDeviceId('高压风机送风湿度(%)'),
          'warningFlag1'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData2',
          this.findDeviceId('前锚温度(℃)'),
          this.findDeviceId('前锚湿度(%)'),
          'warningFlag2'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData3',
          this.findDeviceId('制备站温度(℃)'),
          this.findDeviceId('制备站湿度(%)'),
          'warningFlag8'
        )
        const findDeviceData1 = this.findDeviceData(
          __data,
          '高压风机送风压力(Pa)'
        )
        const findDeviceData2 = this.findDeviceData(
          __data,
          '高压风机送风流量(m?/h)'
        )
        const findDeviceData3 = this.findDeviceData(__data, '初效过滤压差(Pa)')
        const findDeviceData4 = this.findDeviceData(__data, '中效过滤压差(Pa)')
        const findDeviceData5 = this.findDeviceData(__data, '高效过滤压差(Pa)')
        this.pressure = {
          data: findDeviceData1.value
        }
        this.flowData = {
          data: findDeviceData2.value
        }
        this.SingleSolidPieData0 = {
          data1: findDeviceData1.value
        }
        this.SingleSolidPieData1 = {
          data1: findDeviceData3.value
        }
        this.SingleSolidPieData2 = {
          data1: findDeviceData4.value
        }
        this.SingleSolidPieData3 = {
          data1: findDeviceData5.value
        }
        this.warningFlag2 = findDeviceData1.errorLevel
        this.warningFlag3 = findDeviceData2.errorLevel
        this.warningFlag4 = findDeviceData3.errorLevel
        this.warningFlag5 = findDeviceData4.errorLevel
        this.warningFlag6 = findDeviceData5.errorLevel
        this.SwitchStatusData1 = {
          data: __data[this.findDeviceId('变频器运行(开关)')].value,
          isError: __data[this.findDeviceId('变频器运行(开关)')].errorLevel
        }
        this.SwitchStatusData2 = {
          data: __data[this.findDeviceId('锚室送风机指示(开关)')].value,
          isError: __data[this.findDeviceId('锚室送风机指示(开关)')].errorLevel
        }
        this.SwitchStatusData3 = {
          data: __data[this.findDeviceId('锚室送风机故障(开关)')].value,
          isError: __data[this.findDeviceId('锚室送风机故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData4 = {
          data: __data[this.findDeviceId('变频器故障(开关)')].value,
          isError: __data[this.findDeviceId('变频器故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData5 = {
          data: __data[this.findDeviceId('高压风机指示(开关)')].value,
          isError: __data[this.findDeviceId('高压风机指示(开关)')].errorLevel
        }
        this.SwitchStatusData6 = {
          data: __data[this.findDeviceId('高压送风机故障(开关)')].value,
          isError: __data[this.findDeviceId('高压送风机故障(开关)')].errorLevel,
          isZh: true
        }
        this.RunningTimeData1 =
          __data[this.findDeviceId('锚室送风机运行时间(运行时间)')].value
        this.RunningTimeData2 =
          __data[this.findDeviceId('高压风机运行时间(运行时间)')].value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  width: calc(100% - 60px) !important;
  padding-top: 10px;
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    align-content: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 6) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
    &-col {
      display: flex;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      background-color: transparent;
    }
  }
  .run-time-wrap {
    height: 56%;
  }
}
</style>
